@if (stageService.showStageBanner()) {
  <div class="stage-bar">
    <span class="stage-spark stage-spark--warn" aria-hidden="true">✦</span>
    <span class="stage-spark stage-spark--teal" aria-hidden="true">✦</span>
    <span class="stage-spark stage-spark--rose" aria-hidden="true">✦</span>
    <span
      class="stage-label"
      title="Doppelklick blendet den Hinweis für diese Sitzung aus"
      (dblclick)="stageService.hideStageBanner.set(true)"
    >
      <span class="stage-dot" aria-hidden="true"></span>
      @switch (stageService.stage) {
        @case ('env-test') {
          Test-Umgebung
        }
        @case ('env-demo') {
          Demo-Umgebung
        }
        @default {
          {{ stageService.stage }}
        }
      }
    </span>
  </div>
}
